// Pure gate for ModalComponent#contentContainerClicked.
//
// Dismiss only when the event lands on the content container itself (the empty
// area around the modal box). Clicks on ANY child — the content box, or chrome
// portaled into the modal layer as a sibling of `.t-modal-content` (builder
// level/adder pills live in `.js-node-visual-controls-overlay` inside
// `.t-modal-content-outer`) — must not close the modal.
//
// Extracted so unit tests exercise the same function the controller calls.
export const COMPAT_MOUSE_WINDOW_MS = 1000

export function shouldDismissOnContentContainerClick(
  event,
  { dismissable, closeOnOverlayClick, ignoreOverlayDismissUntil = 0, lastTouchAt = 0, now = Date.now() }
) {
  if (ignoreOverlayDismissUntil && now < ignoreOverlayDismissUntil) {
    return false
  }

  // A tap fires touchstart, then a compatibility mousedown. The touchstart
  // already dismissed (or was vetoed by a beforeHide guard), so ignore the mouse
  // event that follows it (ENG-38116).
  if (event.type === 'mousedown' && lastTouchAt && now - lastTouchAt < COMPAT_MOUSE_WINDOW_MS) {
    return false
  }

  return (
    event.target === event.currentTarget &&
    !!event.target?.isConnected &&
    !!dismissable &&
    !!closeOnOverlayClick
  )
}

// Runs the gate, then close(). `state.lastTouchAt` is stamped again AFTER close()
// returns for a touchstart: a beforeHide guard may block in confirm(), and the
// compatibility mousedown only arrives once the dialog is answered, however long
// that takes (ENG-38116).
export function dismissOnContentContainerClick(event, state, options, close, now = Date.now) {
  const lastTouchAt = state.lastTouchAt
  try {
    if (event.type === 'touchstart') state.lastTouchAt = now()
    if (shouldDismissOnContentContainerClick(event, { ...options, lastTouchAt, now: now() })) close()
  } finally {
    if (event.type === 'touchstart') state.lastTouchAt = now()
  }
}
